import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { isOpenAiAdsEnabled, OPENAI_CONSENT_CHANGED } from './index'
import {
  identifyOpenAiCustomer,
  isOpenAiLandingPage,
  syncOpenAiPixel,
  trackOpenAiEvent
} from './pixel'
import { getCustomerId, getUserDataFromAnalytics } from '@helpers/session/user'

export default function useOpenAiPixel() {
  const router = useRouter()

  useEffect(() => {
    syncOpenAiPixel()
    // Reuse persisted traits only when they belong to the recognised customer.
    // Anonymous/stale Segment traits must not identify a different shopper.
    try {
      const customerId = getCustomerId()
      const stored = getUserDataFromAnalytics()
      if (customerId && stored.id === customerId) {
        identifyOpenAiCustomer({
          externalId: customerId,
          email: stored.traits.email,
          firstName: stored.traits.firstName,
          lastName: stored.traits.lastName,
          phone: stored.traits.phoneNumber
        })
      }
    } catch {
      // Corrupt or unavailable analytics storage must not affect browsing.
    }
    window.addEventListener(OPENAI_CONSENT_CHANGED, syncOpenAiPixel)
    return () => {
      window.removeEventListener(OPENAI_CONSENT_CHANGED, syncOpenAiPixel)
    }
  }, [])

  useEffect(() => {
    if (isOpenAiAdsEnabled() && isOpenAiLandingPage(router.pathname)) {
      trackOpenAiEvent('page_viewed', { type: 'contents' })
    }
  }, [router.asPath, router.pathname])
}
